import defaultLocale from './default';
import {isObject} from 'lodash';

export default function getTranslated(data, locale, allowEmpty) {
  if (data && isObject(data)) {
    const text = locale && data[locale.replace('-', '_')];
    return text ? text : allowEmpty ? '' : data[defaultLocale.replace('-', '_')];
  } else return data;
}
